export default __webpack_public_path__ + "static/media/g.efa560d3.svg";